const selectTemplates = state => state.templates;

const selectGeneratingPropsFromTemplates = ({
  polling,
  dataUrl,
  generatingError,
  generatingErrorMessages,
}) => ({
  polling,
  dataUrl,
  generatingError,
  generatingErrorMessages,
});

export const selectGeneratingProps = state =>
  selectGeneratingPropsFromTemplates(selectTemplates(state));



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/TemplateGenerator/TemplateGeneratorSelectors.js